<div class="contains w-100 align-items-center d-flex flex-column mt-5">
   <div class="col-12 d-flex justify-content-center">
      <div class="mr-auto ml-auto mb-5">
         <h5>
            {{ 'public.tracking.find-orders.info' | translate }}
         </h5>
         <h5 class="mt-3">
            {{ 'public.tracking.find-orders.num' | translate }}
         </h5>
      </div>
   </div>
   <div *ngFor="let control of formArr.controls; index as i" class="form-group col-12 mt-3">
      <div class="md col-xl-8 col-12 d-flex align-items-center justify-content-center mr-auto ml-auto">
         <input
            #inputs
            type="text"
            class="form-control col-11"
            [formControl]="getFormControl(control)"
            placeholder="Ex: 0220764658953843"
         />
         <button *ngIf="i != 0" type="button" class="btn btn-circle col-1" (click)="remove(i)">
            <i class="fas fa-times"></i>
         </button>
      </div>
   </div>

   <div class="col-7 mb-1 mt-4">
      <button
         type="button"
         class="btn-add ml-auto"
         (click)="addInput()"
         placement="top"
         ngbTooltip="{{ translatePath + 'tooltip' | translate }}"
         [disabled]="formArr.controls.length >= 5"
      >
         <i class="fas fa-plus"></i>
      </button>
   </div>
   <div class="col-6 align-self-center text mb-3 d-flex justify-content-center">
      <span *ngIf="noData" class="text-danger text-center"
         ><i class="bi bi-exclamation-circle mr-3"></i>{{ translatePath + 'data' | translate }} {{ value }}
         {{ translatePath + 'no-data' | translate }}</span
      >
   </div>

   <div class="form-group col-12 col-md-5 mt-5">
      <div class="w-100 align-items-end d-flex flex-row">
         <button
            [disabled]="!isAvailableSearch() || loading"
            (click)="search()"
            class="btn btn-outline-info ml-auto mr-auto"
         >
            <i class="bi bi-search mr-auto" [class.color]="isAvailableSearch()"></i
            ><span class="mr-auto">{{ 'public.tracking.find-orders.search' | translate }}</span>
         </button>
      </div>
   </div>
   <app-order-row class="col-12 col-md-10 mt-3" *ngFor="let item of resultList" [order]="item"></app-order-row>
</div>
